export enum SortDirection {
  Ascending = 'asc',
  Descending = 'desc'
}



// WEBPACK FOOTER //
// ./src/app/models/sort-direction.enum.ts